<template>
    <div class="purchase_part my-2">
        <cabinet-fl44-card-header :purchase="contract" />
        <cabinet-fl44-card-body>
            <template v-slot:col1>
                <cabinet-notice-card-row-single v-if="isContractConcluded" label="Контракт заключен">
                    {{ getDateFormat(contract.purchase_info.contract_conclusion_date) }}
                </cabinet-notice-card-row-single>
                <cabinet-notice-card-row-single v-if="contract.purchase_info.contract_execution_date" label="Контракт исполнен:">
                    {{ getDateFormat(contract.purchase_info.contract_execution_date) }}
                </cabinet-notice-card-row-single>
                <cabinet-notice-card-row-single v-if="contract.purchase_info.contract_price" label="Цена контракта"> {{ $formatPrice(contract.purchase_info.contract_price) }} руб. </cabinet-notice-card-row-single>
                <cabinet-notice-card-row-single v-if="contract.purchase_info.contract_price_with_supplementary_agreement" label="Цена контракта с учётом ДС"> {{ $formatPrice(contract.purchase_info.contract_price_with_supplementary_agreement) }} руб. </cabinet-notice-card-row-single>
                <purchase-comment-edit-block v-if="contract.flags.is_customer" :purchase="contract" @refresh="refresh" />
            </template>
            <template v-slot:col2>
                <cabinet-notice-card-row-dual v-if="contract.purchase_info.purchase_name" label="Предмет закупки">
                    {{ contract.purchase_info.purchase_name }}
                </cabinet-notice-card-row-dual>
                <cabinet-notice-card-row-dual v-if="contract.flags.is_supplier" label="Заказчик">
                    <router-link :to="{ name: 'OrganizationShow', params: { id: contract.customer.id } }" class="system_link-style" target="_blank">
                        {{ contract.customer.name }}
                    </router-link>
                </cabinet-notice-card-row-dual>
                <cabinet-notice-card-row-dual v-if="contract.flags.is_customer" label="Поставщик">
                    <template v-if="!contract.supplier.id"> &mdash; </template>
                    <template v-else>
                        <template v-if="contract.supplier.type === 'private'">
                            {{ contract.supplier.name }}
                        </template>
                        <router-link v-else :to="{ name: 'OrganizationShow', params: { id: contract.supplier.id } }" class="system_link-style" target="_blank">
                            {{ contract.supplier.name }}
                        </router-link>
                    </template>
                </cabinet-notice-card-row-dual>
                <cabinet-notice-card-row-single label="Количество позиций">{{ contract.purchase_info.deliverables_count }} </cabinet-notice-card-row-single>
            </template>
            <template v-slot:col3>
                <cabinet-fl44-card-info-link :to="{ name: 'ExternalPurchaseShow', params: { id: contract.id } }" icon="search">Информация о закупке</cabinet-fl44-card-info-link>
                <cabinet-fl44-card-info-link :to="{ name: 'ExternalPurchaseShow', params: { id: contract.id }, hash: '#contract' }" icon="contract">Контракт</cabinet-fl44-card-info-link>
                <cabinet-fl44-card-info-link v-if="contract.flags.has_supplementary_agreements" :to="{ name: 'ExternalPurchaseShow', params: { id: contract.id }, hash: '#supplementary-agreements' }" icon="contract">Дополнительные соглашения</cabinet-fl44-card-info-link>
                <b-btn v-if="contract.actions.edit_draft" :to="{ name: 'ExternalPurchaseCreate', params: { mode: 'edit_draft', id: contract.id } }" class="btn btn-card-action btn-card-action-green my-1">Редактировать</b-btn>
                <cabinet-fl44-external-purchase-delete-button v-if="contract.actions.delete" :contract="contract" @refresh="refresh" />
                <b-btn v-if="contract.actions.edit" :to="{ name: 'ExternalPurchaseEdit', params: { id: contract.id } }" class="btn btn-card-action my-1">Редактировать</b-btn>
                <cabinet-fl44-external-purchase-card-copy-button :contract="contract" />
                <cabinet-fl44-external-purchase-block-request-button v-if="contract.flags.is_customer" :contract="contract" @refresh="refresh" />
            </template>
        </cabinet-fl44-card-body>
    </div>
</template>

<script>
import PurchaseCommentEditBlock from '@/components/common/purchase-comment-edit-block.vue';
import CabinetFl44ExternalPurchaseBlockRequestButton from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-external-purchase-block-request-button.vue';
import CabinetFl44CardHeader from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-card-header.vue';
import CabinetNoticeCardRowSingle from '@/components/cabinet/partials/cabinet-notice-card-row-single.vue';
import CabinetFl44CardBody from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-card-body.vue';
import CabinetNoticeCardRowDual from '@/components/cabinet/partials/cabinet-notice-card-row-dual.vue';
import CabinetFl44CardInfoLink from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-card-info-link.vue';
import CabinetFl44ExternalPurchaseDeleteButton from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-external-purchase-delete-button.vue';
import CabinetFl44ExternalPurchaseCardCopyButton from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-external-purchase-card-copy-button.vue';

export default {
    name: 'cabinet-fl44-external-purchase-card',
    components: {
        CabinetFl44ExternalPurchaseCardCopyButton,
        CabinetFl44ExternalPurchaseDeleteButton,
        CabinetFl44CardInfoLink,
        CabinetNoticeCardRowDual,
        CabinetFl44CardBody,
        CabinetNoticeCardRowSingle,
        CabinetFl44CardHeader,
        CabinetFl44ExternalPurchaseBlockRequestButton,
        PurchaseCommentEditBlock
    },
    props: {
        contract: {
            type: Object,
            required: true
        }
    },
    methods: {
        refresh() {
            this.$emit('refresh');
        }
    },
    computed: {
        isContractConcluded() {
            return ['contract:active', 'contract:fulfilled', 'contract:unfulfilled', 'contract:terminated'].includes(this.contract.status.id);
        }
    }
};
</script>

<style scoped>
.purchase_part {
    background: #fff;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    border: 1px solid #d9d9de;
}
</style>
